module.exports = __webpack_public_path__ + "static/media/flag-id.0b75c86a.webp";